module.exports = "<p>\n  admin-page-card-item works!\n</p>\n"